export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-[#262364] text-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-3 gap-12 mb-12">
          {/* Column 1 - Logo */}
          <div>
            <img
              src="https://static.readdy.ai/image/49e3304430570b21ebb630f9a5f081b3/7b22204017c50d4f304e554e533f6383.jpeg"
              alt="AAPEQ"
              className="h-12 w-auto mb-4"
            />
            <p className="text-sm text-white/70 leading-relaxed">
              Academia Artística Primordial Energy Quantum — Transformando artistas em alta performance através de técnica, energia e consciência.
            </p>
          </div>

          {/* Column 2 - Quick Links */}
          <div>
            <h3 className="text-lg font-bold mb-4">Links Rápidos</h3>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => scrollToSection('sobre')}
                  className="text-sm text-white/80 hover:text-[#F05954] transition-colors cursor-pointer"
                >
                  Sobre a AAPEQ
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('para-quem')}
                  className="text-sm text-white/80 hover:text-[#F05954] transition-colors cursor-pointer"
                >
                  Para Quem É
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('areas')}
                  className="text-sm text-white/80 hover:text-[#F05954] transition-colors cursor-pointer"
                >
                  Áreas de Atuação
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('metodologia')}
                  className="text-sm text-white/80 hover:text-[#F05954] transition-colors cursor-pointer"
                >
                  Metodologia
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('faq')}
                  className="text-sm text-white/80 hover:text-[#F05954] transition-colors cursor-pointer"
                >
                  FAQ
                </button>
              </li>
            </ul>
          </div>

          {/* Column 3 - Social & Contact */}
          <div>
            <h3 className="text-lg font-bold mb-4">Redes Sociais</h3>
            <div className="flex gap-4 mb-6">
              <a
                href="https://instagram.com/aapeq"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-[#F05954] transition-all cursor-pointer"
              >
                <i className="ri-instagram-line text-xl"></i>
              </a>
              <a
                href="https://facebook.com/aapeq"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-[#F05954] transition-all cursor-pointer"
              >
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <a
                href="https://youtube.com/@aapeq"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-[#F05954] transition-all cursor-pointer"
              >
                <i className="ri-youtube-fill text-xl"></i>
              </a>
            </div>
            <p className="text-sm text-white/70 leading-relaxed">
              <strong className="text-white">Instagram:</strong><br />
              Mensagem: "QUERO MINHA VAGA"
            </p>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/20 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-white/60">
              © 2026 AAPEQ. Todos os direitos reservados.
            </p>
            <a
              href="https://suritarafa.com.br"
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm text-white/60 hover:text-[#F05954] transition-colors"
            >
              Desenvolvido por Suritarafa
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
